<div class="ziro-admin-page-content">
  <div class="col-md-10 offset-md-1 pb-2 ziro-report-content">
    <ziro-breadcrumbs>
      <ziro-breadcrumb-card-item>
        <div
          [innerHTML]="
            (isReadOnly
              ? 'tkey;reports.global_directory.description.read_only'
              : 'tkey;reports.global_directory.description'
            ) | escapeHtml
          "
        ></div>
      </ziro-breadcrumb-card-item>
    </ziro-breadcrumbs>

    @if (isDisplayAlert) {
      <div class="card border-primary text-center mb-3" data-automation="global-directory-report-build-alert">
        <div class="card-body strong">
          <i class="{{ ziroIcons.SAVING }} pe-1"></i>
          <span>{{ 'tkey;reports.global_directory.building' | translate }}</span>
        </div>
      </div>
    }

    @if (timeStamp && (timeStamp.includes('day') || timeStamp.includes('month') || timeStamp.includes('year'))) {
      <div data-automation="global-directory-report-stale-data-alert" class="alert alert-warning">
        <div [innerHTML]="'tkey;reports.stale_data.alert' | escapeHtml: { timeStamp: timeStamp }"></div>
        <button
          data-automation="refresh-global-directory-data"
          [disabled]="isLoading"
          [ngClass]="isLoading ? 'warning text-warning' : ''"
          class="btn btn-border btn-link"
          (click)="refreshGlobalDirectoryData()"
        >
          @if (!isLoading) {
            <span>
              <i [ngClass]="ziroIcons.REFRESH"></i>
              {{ 'tkey;reports.refresh_data.link' | translate }}
            </span>
          }
          @if (isLoading) {
            <span>
              <i [ngClass]="ziroIcons.SAVING"></i>
              {{ 'tkey;reports.refreshing_data.text' | translate }}
            </span>
          }
        </button>
      </div>
    }

    <ziro-loading-block [hidden]="!isLoading"></ziro-loading-block>

    @if (!isLoading && !isDisplayAlert) {
      <ziro-datatable
        [class]="'ziro-card'"
        [isCondensed]="true"
        [columns]="columns"
        [rowDataSource]="results"
        [uniqueRowIdentifier]="'ldapUserId'"
        [showSelectColumn]="!isReadOnly"
        [mainFilterPlaceholder]="
          ('tkey;reports.datatable.search_placeholder' | translate) +
          ('tkey;reports.global_directory.ldap_user_id.label' | translate) +
          ', ' +
          ('tkey;reports.global_directory.cucm_extension.label' | translate) +
          ', ' +
          ('tkey;reports.global_directory.ldap_extension.label' | translate) +
          ', ' +
          ('tkey;reports.global_directory.ldap_did.label' | translate)
        "
        [noResultsAlert]="getNoResultsAlert()"
        [noResultsAlertClass]="getNoResultsAlertClass()"
        (rowSelected)="onRowSelected()"
        [dataAutomation]="tableDataAutomation"
        (isViewStillLoading)="isViewLoading($event)"
      >
        <ziro-datatable-switch-filter
          [label]="'tkey;reports.global_directory.hide' | translate"
          [matchFn]="showOnlyMisconfiguredFilter"
          [dataAutomation]="'show-only-misconfig-switch-filter'"
          [tableId]="tableDataAutomation"
        ></ziro-datatable-switch-filter>
      </ziro-datatable>
    }
  </div>
</div>

<ziro-bottom-nav data-automation="reports-global-directory-bottom-nav"></ziro-bottom-nav>
